import React from "react";
import productService from "../services/productService";
import { showProcess, hideProcess, getFileServer, UserSession, getUrlApi } from "../utils/util";
import { Galleria } from "primereact/galleria";
import shoppingCartService from "../services/shoppingCartService";
import bannersService from "../services/bannersService";
import { Paginator } from "primereact/paginator";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productsHighlight: [],
            windowWidth: window.innerWidth,
            fileServer: getFileServer(),
            products: [],
            first: 0,
            rows: 20,
            totalRecords: 0,
        };
    }

    async componentDidMount() {
        try {
            await showProcess();
            const response = await productService.getHighlights();

            const responseBanners = await bannersService.getBanners();

            this.urlApi = await getUrlApi();
            
            const responseProducts = await productService.getByStatusAndTypeAndLikeName(
                "ACTIVE",
                "VIRTUAL",
                null,
                null
            );
    
            if (response.status === 200) {
                this.setState({
                    productsHighlight: response.data.filter((p) => !p.child),
                    banners: responseBanners.data.sort((a, b) => a.index - b.index),
                    products: responseProducts.data.filter((p) => !p.child)
                });
            } else {
                alert("ERRO AO CARREGAR PAGINA");
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data);
            } else {
                console.log("message", err.message);
            }
        }

        try {
            if (UserSession !== null) {
                var shoppingCart = JSON.parse(localStorage.getItem("shoppingCart"));

                if (
                    shoppingCart !== null &&
                    shoppingCart !== undefined &&
                    shoppingCart.lines.length > 0
                ) {
                    shoppingCartService.convert(shoppingCart).then((response) => {
                        if (response.status === 200) {
                            localStorage.removeItem("shoppingCart");
                            this.props.refreshCart();
                        }
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }

        hideProcess();

        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    listPrices(product) {
        if (product.childProducts !== undefined) {
            var prices = "";
            product.childProducts.forEach((p) => (prices += "R$ " + p.amount + " | "));
            prices = prices.substring(0, prices.length - 3);
            return prices;
        } else {
            return "R$ " + product.amount;
        }
    }

    onPageChange = async (event) => {
        await showProcess();
        await this.setState({ first: 0, rows: 0 });
        await this.setState({ first: event.first, rows: event.rows });
        hideProcess();
        
        // Scroll para o início da segunda section
        if (this.allProductsSection) {
            this.allProductsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    render() {
        const { windowWidth } = this.state;
        const isMobile = windowWidth <= 768;

        return (
            <>
                {/* BANNER PRINCIPAL */}
                <Galleria
                    transitionInterval={6000}
                    value={this.state.banners}
                    autoPlay
                    circular
                    item={(item) => (
                        <img
                            src={`${this.urlApi}/resources/banners/${item.id}.banner`}
                            onClick={() => window.location.href = item.command}
                            style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                borderRadius: "10px",
                                cursor: item.command ? "pointer" : "default"
                            }}
                            alt="banner"
                        />
                    )}
                    showThumbnails={false}
                    showIndicators
                    style={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "100%",
                    }}
                />

                
                <section
                    className="app-cards-container"
                    style={{
                        marginTop: "25px",
                        padding: "0px",
                        width: "100%",
                        boxSizing: "border-box",
                        backgroundColor: "#E0D8E8",
                    }}
                >
                    <div style={{textAlign: "left", padding: "40px 40px 0px 40px"}}>
                        <label style={{fontSize: "20px", color: "var(--unnamed-color-411172)", fontWeight: "600"}}>Cartões-Presente Populares</label>
                    </div>    
                    <div
                        className="app-cards-products"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: isMobile ? "12px" : "25px",
                            width: "100%",
                            boxSizing: "border-box",
                            overflow: "hidden",
                        }}
                    >
                        {this.state.productsHighlight.map((p, i) => (
                            <div
                                    className="app-card-product"
                                    onClick={() => (window.location.href = "/product/" + p.id)}
                                    style={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #ddd",
                                        borderRadius: "10px",
                                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        padding: "25px 0px 20px",
                                        width: window.innerWidth < 768 ? "90%" : "300px", // ← aqui o ajuste
                                        minWidth: "150px",
                                        textAlign: "center",
                                        transition: "transform 0.2s ease-in-out",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: "auto",
                                        margin: window.innerWidth < 768 ? "10px auto" : "0", // centraliza no mobile
                                    }}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.style.transform = "scale(1.05)")
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.style.transform = "scale(1)")
                                    }
                                >
                                    <img
                                        src={`${this.state.fileServer}/cards/${p.id}.png`}
                                        alt={p.displayName}
                                        style={{
                                            width: "100%",
                                            height: "170px",
                                            objectFit: "contain",
                                            borderRadius: "10px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                    <span
                                        className="app-card-product-name"
                                        style={{
                                            display: "block",
                                            fontSize: "20px",
                                            fontWeight: "500",
                                            color: "#000141",
                                            minHeight: "40px",
                                            lineHeight: "1.2em",
                                            marginBottom: "5px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {p.displayName}
                                    </span>
                                    <p
                                        className="app-card-product-price"
                                        style={{
                                            color: "#707070",
                                            fontSize: "15px",
                                            margin: "10px 0",
                                            flexGrow: 0,
                                        }}
                                    >
                                        {this.listPrices(p)}
                                    </p>
                                    
                                    <div style={{width:"100%", textAlign: "center"}}>
                                        <button
                                            style={{
                                                backgroundColor: "#411172",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "50px",
                                                padding: "15px 25px",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                                width: "fit-content",
                                                fontWeight: "500",
                                                marginTop: "auto",
                                            }}
                                        >
                                            Comprar
                                        </button>
                                    </div>
                                    
                                </div>
                        ))}
                    </div>
                </section>

                <section
                    ref={(ref) => (this.allProductsSection = ref)}
                    className="app-cards-container"
                    style={{
                        padding: "10px",
                        width: "100%",      
                        boxSizing: "border-box",
                        backgroundColor: "#F3F3F3"
                    }}
                >
                    <div style={{textAlign: "left", padding: "40px 40px 0px 40px"}}>
                        <label style={{fontSize: "20px", color: "var(--unnamed-color-411172)", fontWeight: "600"}}>Todos Cartões-Presente</label>
                    </div>                    
                    <div
                        class="app-cards-products"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                            gap: "20px",
                            width: "100%",
                            
                        }}
                    >
                        {this.state.products
                            .filter((p) =>
                                p.displayName
                                    .toUpperCase()
                                    .includes(this.props.search.toUpperCase())
                            )
                            .splice(this.state.first, this.state.rows)
                            .map((p) => (
                                <div
                                    className="app-card-product"
                                    onClick={() => (window.location.href = "/product/" + p.id)}
                                    style={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #ddd",
                                        borderRadius: "10px",
                                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        padding: "20px 0px 25px",
                                        width: window.innerWidth < 768 ? "90%" : "300px", // ← aqui o ajuste
                                        minWidth: "150px",
                                        textAlign: "center",
                                        transition: "transform 0.2s ease-in-out",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: "auto",
                                        margin: window.innerWidth < 768 ? "10px auto" : "0", // centraliza no mobile
                                    }}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.style.transform = "scale(1.05)")
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.style.transform = "scale(1)")
                                    }
                                >
                                    <img
                                        src={`${this.state.fileServer}/cards/${p.id}.png`}
                                        alt={p.displayName}
                                        style={{
                                            width: "100%",
                                            height: "170px",
                                            objectFit: "contain",
                                            borderRadius: "10px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                    <span
                                        className="app-card-product-name"
                                        style={{
                                            display: "block",
                                            fontSize: "20px",
                                            fontWeight: "500",
                                            color: "#000141",
                                            minHeight: "40px",
                                            lineHeight: "1.2em",
                                            marginBottom: "5px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {p.displayName}
                                    </span>
                                    <p
                                        className="app-card-product-price"
                                        style={{
                                            color: "#707070",
                                            fontSize: "15px",
                                            margin: "10px 0",
                                            flexGrow: 0,
                                        }}
                                    >
                                        {this.listPrices(p)}
                                    </p>
                                    
                                    <div style={{width:"100%", textAlign: "center"}}>
                                        <button
                                            style={{
                                                backgroundColor: "#411172",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "50px",
                                                padding: "15px 25px",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                                width: "fit-content",
                                                fontWeight: "500",
                                                marginTop: "auto",
                                            }}
                                        >
                                            Comprar
                                        </button>
                                    </div>
                                    
                                </div>
                            ))}
                    </div>
                </section>
                
                {this.state.products.length > 20 && (
                    <Paginator
                        className="app-store-paginator"
                        first={this.state.first}
                        rows={this.state.rows}
                        totalRecords={this.state.products.length}
                        rowsPerPageOptions={[10, 20, 30]}
                        onPageChange={this.onPageChange}
                    />
                )}

                {/* BANNER FINAL */}
                <img
                    src={require("../img/Banner002.png")}
                    alt="banner"
                    style={{
                        width: "100%",
                        marginTop: "50px",
                        height: isMobile ? "auto" : "auto",
                        objectFit: "contain",
                    }}
                />

                <div style={{width: "100%", textAlign: "center", marginTop: "100px", marginBottom: "100px"}}>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "43px", fontWeight: "600"}}>
                        Precisa comprar em lote, maiores quantidades ou cartões-presente de outras marcas?
                    </label>
                    <br/>
                    <br/>
                    <label style={{color: "var(--unnamed-color-411172)", fontSize: "29px", fontWeight: "500"}}>
                        Você passa qual a sua necessidade e nós resolvemos todo o resto.
                        <br/>
                        Fale com um dos nossos especialistas!
                    </label>
                    <br/>
                    <br/>
                    <br/>
                    <button onClick={() => window.location.href = "https://api.whatsapp.com/send/?phone=5511942505855&text=Ol%C3%A1%2C+gostaria+de++saber+mais+sobre+a+BHN&type=phone_number&app_absent=0"}
                            style={{backgroundColor: "var(--unnamed-color-411172)", color: "#fff", border: "none", borderRadius: "50px", padding: "20px 80px", fontSize: "30px", cursor: "pointer", fontWeight: "600"}}>Entrar em contato</button>
                </div>
            </>
        );
    }
}
